import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; // ✅ Import toast
import "../styles/Register.css";

export default function Register() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    // Prevent double clicks
    if (loading) return;

    // Normalize inputs
    const normalizedEmail = email.trim().toLowerCase();
    const normalizedName = name.trim();

    if (!normalizedEmail || !normalizedName) {
      toast.error("Name and Email are required.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://globisun-app.onrender.com/api/auth/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: normalizedEmail,
            name: normalizedName,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.msg || data.message || "Failed to send OTP");
        return;
      }

      toast.success("OTP sent to your email 📩");

      navigate(
        `/verify-otp?email=${encodeURIComponent(
          normalizedEmail
        )}&name=${encodeURIComponent(
          normalizedName
        )}&category=${encodeURIComponent(category)}`
      );
    } catch (err) {
      console.error(err);
      toast.error("Error sending OTP ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <h2 className="register-title">Register as {category}</h2>

        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={handleSendOtp} disabled={loading}>
          {loading ? "Sending OTP..." : "Verify Email"}
        </button>

        {/* Sign In Option */}
        <p className="register-signin">
          Already have an account?{" "}
          <span
            className="register-signin-link"
            onClick={() => navigate("/login")}
          >
            Sign In
          </span>
        </p>
      </div>
    </div>
  );
}
